import React, { useEffect, useState, useMemo, useCallback } from "react";
import CommonDataTable from "../../components/CommonDataTable";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { fetchDoorlocs } from "../../services/doorloc/doorloc";

const mapDoorlocRows = (apiData = []) =>
  apiData.map((item) => ({
    id: item._id,
    __raw: item,
    Warehouse: item.Warehouse ?? "",
    Loc: item.Loc ?? "",
    LocationType: item.LocationType ?? "",
    LocationCategory: item.LocationCategory ?? "",
    LocationHandling: item.LocationHandling ?? "",
    ABC: item.ABC ?? "",
    Section: item.Section ?? "",
    LocationFlag: item.LocationFlag ?? "",
    Status: item.Status ?? "",
    PickZone: item.PickZone ?? "",
    Height: item.Height ?? "",
    Length: item.Length ?? "",
    Width: item.Width ?? "",
    Cube: item.Cube ?? "",
    WeightCapacity: item.WeightCapacity ?? "",
    CubicCapacity: item.CubicCapacity ?? "",
    PutawayZone: item.PutawayZone ?? "",
    PickMethod: item.PickMethod ?? "",
    SectionKey: item.SectionKey ?? "",
    XCoord: item.XCoord ?? "",
    YCoord: item.YCoord ?? "",
    ZCoord: item.ZCoord ?? "",
    LocLevel: item.LocLevel ?? "",
    addwho: item.addwho ?? "",
    editwho: item.editwho ?? "",
    AddDate: item.AddDate ?? "",
    editdate: item.editdate ?? "",
  }));

const baseColumns = [
  { field: "Warehouse", headerName: "Warehouse", width: 120 },
  { field: "Loc", headerName: "Location", width: 120 },
  { field: "LocationType", headerName: "Location Type", width: 150 },
  { field: "LocationCategory", headerName: "Location Category", width: 170 },
  { field: "LocationHandling", headerName: "Location Handling", width: 170 },
  { field: "LocationFlag", headerName: "Location Flag", width: 170 },
  { field: "Status", headerName: "Status", width: 120 },
  { field: "Section", headerName: "Section", width: 120 },
  { field: "PickZone", headerName: "Pick Zone", width: 120 },
  { field: "Height", headerName: "Height", width: 100 },
  { field: "Length", headerName: "Length", width: 100 },
  { field: "Width", headerName: "Width", width: 100 },
  { field: "Cube", headerName: "Cube", width: 100 },
  { field: "addwho", headerName: "Added By", width: 140 },
  { field: "editwho", headerName: "Edited By", width: 140 },
  { field: "AddDate", headerName: "Add Date", width: 170 },
  { field: "editdate", headerName: "Edit Date", width: 170 },
];

export default function DoorlocList({ onView }) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const loadData = useCallback(
    async (pageNo = 0, pageSizeNo = 10) => {
      try {
        const res = await fetchDoorlocs(pageNo, pageSizeNo);

        const list =
          res?.data?.data ||
          res?.data ||
          [];

        const totalCount =
          res?.data?.meta?.total ||
          res?.pagination?.totalRecords ||
          list.length;

        setRows(mapDoorlocRows(list));
        setTotal(totalCount);
      } catch (err) {
        console.error("Doorloc fetch error:", err);
        setRows([]);
        setTotal(0);
      }
    },
    []
  );

  useEffect(() => {
    loadData(page, pageSize);
  }, [loadData, page, pageSize]);

  const actionColumn = useMemo(
    () => ({
      field: "__actions",
      headerName: "",
      width: 50,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setMenuAnchorEl(e.currentTarget);
            setMenuRow(params.row);
          }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      ),
    }),
    []
  );

  return (
    <>
      <CommonDataTable
        id="doorloc-list"
        allPossibleColumns={[actionColumn, ...baseColumns]}
        initialVisible={["__actions", ...baseColumns.map((c) => c.field)]}
        initialRows={rows}
        rowCount={total}
        page={page}
        pageSize={pageSize}
        rowsPerPageOptions={[10, 20, 50]}
        height={500}
        checkboxSelection
        forInventory
        readOnly

        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
          setPage(0);
        }}

        // ✅ CRITICAL (same as GRN)
        onDataRefresh={({ page: p = 0, pageSize: ps = 10 } = {}) =>
          loadData(p, ps)
        }
      />

      <Menu
        open={Boolean(menuAnchorEl)}
        anchorEl={menuAnchorEl}
        onClose={() => setMenuAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            onView(menuRow.id);
            setMenuAnchorEl(null);
          }}
        >
          <i className="bi bi-eye me-2" />
          View
        </MenuItem>
      </Menu>
    </>
  );
}